import { z } from 'zod';

export const visualizationTypes = ['swimlane', 'timeline', 'table'] as const;
export const visualizationTypeSchema = z.enum(visualizationTypes);

export type VisualizationType = z.infer<typeof visualizationTypeSchema>;

export const VISUALIZATION_TYPE_TRANSLATIONS = {
  swimlane: 'roadmapping.visualizationType.swimlane',
  timeline: 'roadmapping.visualizationType.timeline',
  table: 'roadmapping.visualizationType.table',
} as const satisfies Record<VisualizationType, string>;

export const VISUALIZATION_TYPE_DESCRIPTION_TRANSLATIONS = {
  swimlane: 'roadmapping.create.roadmap.dialog.visualizationType.swimlane',
  timeline: 'roadmapping.create.roadmap.dialog.visualizationType.timeline',
  table: 'roadmapping.create.roadmap.dialog.visualizationType.table',
} as const satisfies Record<VisualizationType, string>;

// Until we support Timeline, we must explicitly limit the visualization types
export const SUPPORTED_VISUALIZATION_TYPES: VisualizationType[] = [
  'swimlane',
  'timeline',
  'table',
] as const;

export const visualizationDTOSchema = z.object({
  visualizationId: z.number().int(),
  organizationId: z.string().min(1),
  viewId: z.number().int(),
  type: visualizationTypeSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type VisualizationDTO = z.infer<typeof visualizationDTOSchema>;

export const visualizationInsertDTOSchema = z
  .object({
    type: visualizationTypeSchema,
  })
  .strict();

export type VisualizationInsertDTO = z.infer<typeof visualizationInsertDTOSchema>;
